<template>
  <div
    class="flex flex-col py-4 md:pt-8 px-4 md:px-6 md:pb-6 mt-auto gap-3 bg-primary max-md:border-t border-secondary"
  >
    <Button
      :label="primaryLabel"
      size="xl"
      :disabled="disablePrimary"
      :loading="busy"
      @click.stop="$emit('primaryAction')"
    />
    <Button
      v-if="!maxSmall || content === 'verify'"
      :label="secondaryLabel"
      variant="secondary"
      type="gray"
      size="xl"
      @click.stop="$emit('secondaryAction')"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Button } from "@/SharedComponents/Buttons";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { useI18n } from "vue-i18n";

const { maxSmall } = useBreakpoints();
const { t } = useI18n();

defineEmits(["primaryAction", "secondaryAction"]);

const props = defineProps({
  content: { type: String, required: true },
  disablePrimary: { type: Boolean, required: false },
  busy: { type: Boolean, required: false },
});

const primaryLabel = computed(() =>
  t(
    props.content === "fields"
      ? "components.profile.email.button.confirm"
      : "components.profile.email.button.resend"
  )
);

const secondaryLabel = computed(() =>
  t(
    props.content === "fields"
      ? "components.buttons.cancel"
      : "components.profile.email.button.confirm"
  )
);
</script>
